import { TrackerEvent } from './tracker-event';
import { idToString, createTrackReplayer } from './util';
import { loadScript } from '@day1co/browser-util';

/**
 * @see www/views/_partials/_tracker_kakao.html
 * @see https://ad.kakao.com/contents/contentView/703
 */
export class KakaoTracker {
  static create(opts, context) {
    return new KakaoTracker(opts, context);
  }
  constructor({ id, userId }, context) {
    this.id = id;
    this.userId = userId;
    this.name = 'kakao';

    loadScript('//t1.daumcdn.net/adfit/static/kp.js')
      .then(() => {
        context.kakaoPixel(this.id).pageView();
        // 스크립트 로딩 후에 이벤트를 보내야 함!
        this.kakaoPixel = context.kakaoPixel;
        this.ready = true;
      })
      .catch((err) => console.error('install err!', err));
  }

  getPayloadForTransactionPayment(data) {
    const { transactionInfo, productSaleInfo } = data;
    const payload = { products: [], currency: 'KRW' };

    if (productSaleInfo && productSaleInfo.product && transactionInfo && transactionInfo.transaction) {
      const { quantity, courseId, salePrice, categoryId } = productSaleInfo.product;
      const { amount } = transactionInfo.transaction;
      payload.total_quantity = quantity || 1;
      payload.total_price = amount || 0; // 주문 총 가격(optional)
      payload.products = payload.products.concat({
        id: courseId,
        quantity: 1,
        price: salePrice,
      });
      payload.categoryId = categoryId;
    }

    if (productSaleInfo && productSaleInfo.courses && productSaleInfo.product && payload.products[0]) {
      const { courseId } = productSaleInfo.product;
      const productCourse = productSaleInfo.courses.find((course) => course.id === courseId);
      payload.products[0].name = (productCourse && productCourse.title) || '';
    }

    if (productSaleInfo && productSaleInfo.bundle && productSaleInfo.courses) {
      const products = productSaleInfo.bundle.map((product) => {
        const course = productSaleInfo.courses.find((course) => course.id === product.courseId);
        return {
          id: course && course.id,
          name: course && course.title,
          quantity: 1,
          price: product.salePrice,
        };
      });
      payload.products = payload.products.concat(products);
      // bundle의 요소인 product의 courseId와 같은 course를 courses에서 찾습니다.
      // 찾은 course를 id와 title에 입력합니다. 찾지 못했을 경우 undefined가 입력됩니다.
      // 반환된 array와 기존 payload.products를 합칩니다.
    }

    return payload;
  }

  track(event, data) {
    if (!this.ready) {
      if (process.env['NODE_ENV'] !== 'prod') console.error('**ignore** not ready!', event, data);
      const trackReplayer = createTrackReplayer({ target: this, time: 3 });
      trackReplayer(event, data);
      return;
    }
    switch (event) {
      case TrackerEvent.PAGE_VIEW:
        break;
      case TrackerEvent.USER_SIGNUP:
        this.kakaoPixel(this.id).completeRegistration();
        break;
      case TrackerEvent.USER_LOGIN:
        break;
      case TrackerEvent.FORMAT_VIEW:
        break;
      case TrackerEvent.CATEGORY_VIEW:
        break;
      case TrackerEvent.COURSE_VIEW:
        if (data) {
          const course = data;
          this.kakaoPixel(this.id).viewContent({ id: course.id });
        }
        break;
      case TrackerEvent.ENROLLMENT_VIEW:
        break;
      case TrackerEvent.ENROLLMENT_PENDING:
        if (data) {
          const { product } = data;
          const tag = 'Lead' + idToString(product.categoryId);
          this.kakaoPixel(this.id).viewCart();
          this.kakaoPixel(this.id).viewCart(tag);
        }
        break;
      case TrackerEvent.TRANSACTION_ORDER:
        break;
      case TrackerEvent.TRANSACTION_PAYMENT:
        if (data) {
          const payload = this.getPayloadForTransactionPayment(data);
          const tag = 'Pur' + idToString(payload.categoryId);
          this.kakaoPixel(this.id).purchase(payload);
          this.kakaoPixel(this.id).purchase(tag);
        }
        break;
      case TrackerEvent.COMMON: {
        break;
      }
    }
  }
}
